// YouTube Facade implementation for Shopify with Modal
document.addEventListener('DOMContentLoaded', function() {
  // Preconnect to YouTube
  const linkEl = document.createElement('link');
  linkEl.rel = 'dns-prefetch';
  linkEl.href = 'https://www.youtube.com';
  document.head.appendChild(linkEl);
  
  // Modal elements
  const modal = document.getElementById('video-modal');
  const modalBackground = document.getElementById('video-modal-background');
  const videoToggle = document.getElementById('video-toggle');
  const closeButton = document.querySelector('.modal-close'); // Add this line
  let isModalOpen = false;

  
  // Open modal
  function openModal() {
    if (isModalOpen) return;
    isModalOpen = true;
    document.body.style.overflow = 'hidden';
    modalBackground.style.display = 'block';
    modal.style.display = 'block';
    setTimeout(() => {
      modalBackground.classList.add('show');
      modal.classList.add('show');
    }, 10);
  }
  
  // Close modal
  function closeModal() {
    if (!isModalOpen) return;
    isModalOpen = false;
    document.body.style.removeProperty('overflow'); // Fix the overflow issue
    modalBackground.classList.remove('show');
    modal.classList.remove('show');
  }
  
  // Modal events
  if (videoToggle) videoToggle.addEventListener('click', openModal);
  if (modalBackground) modalBackground.addEventListener('click', closeModal);
  if (closeButton) closeButton.addEventListener('click', closeModal); // Add this line
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isModalOpen) closeModal();
  });
  
  // Prevent modal close when clicking inside
  if (modal) modal.addEventListener('click', (e) => e.stopPropagation());
  
  // Get all youtube facade elements
  const facadeElements = document.querySelectorAll('.youtube-facade');
  
  // Add event listeners to each facade
  facadeElements.forEach(function(element) {
    element.addEventListener('mouseenter', loadVideo);
    element.addEventListener('click', loadVideo);
  });
  
  // Function to load the video
  function loadVideo(event) {
    const element = event.currentTarget;
    const videoSrc = element.getAttribute('data-src');
    
    // Check if the video has already been loaded
    if (!element.getAttribute('data-loaded')) {
      const width = element.offsetWidth;
      const height = element.offsetHeight;
      
      // Replace facade with YouTube video
      element.innerHTML = '<iframe width="' + width + '" height="' + height + '" src="' + videoSrc + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      
      // Set the 'loaded' flag to true
      element.setAttribute('data-loaded', 'true');
    }
  }
});